import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Delay appearance for better UX
    const timer = setTimeout(() => setIsVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Subtle floating animation
    let animationFrame;
    let angle = 0;
    
    const animate = () => {
      angle += 0.02;
      const x = Math.sin(angle) * 3;
      const y = Math.cos(angle * 0.7) * 3;
      setPosition({ x, y });
      animationFrame = requestAnimationFrame(animate);
    };
    
    animate();
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  useEffect(() => {
    // Show tooltip after 3 seconds
    const tooltipTimer = setTimeout(() => setShowTooltip(true), 3000);
    return () => clearTimeout(tooltipTimer);
  }, []);

  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=Olá! Gostaria de mais informações sobre os produtos e serviços da Paulare Empilhadeiras.`;

  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      style={{
        transform: `translate(${position.x}px, ${position.y}px)`
      }}
    >
      {/* Tooltip */}
      <div 
        className={`absolute bottom-full right-0 mb-3 transition-all duration-500 ${
          showTooltip ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
        }`}
      >
        <div className="bg-white rounded-xl shadow-xl p-4 max-w-[240px] relative">
          <button 
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
          >
            <X size={14} />
          </button>
          <p className="text-gray-800 text-sm font-medium mb-1">Precisa de ajuda?</p>
          <p className="text-gray-600 text-xs">Fale conosco pelo WhatsApp!</p>
          {/* Arrow */}
          <div className="absolute bottom-0 right-8 translate-y-full">
            <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white"></div>
          </div>
        </div>
      </div>

      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center"
      >
        {/* Pulse rings */}
        <span className="absolute w-16 h-16 bg-green-500 rounded-full animate-ping opacity-20"></span>
        <span className="absolute w-14 h-14 bg-green-500 rounded-full animate-pulse opacity-30" style={{ animationDelay: '0.5s' }}></span>
        
        {/* Main button */}
        <div className="relative w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-full shadow-lg shadow-green-500/40 flex items-center justify-center group-hover:scale-110 group-hover:shadow-green-500/60 transition-all duration-300">
          <MessageCircle size={28} className="text-white fill-white" />
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
